module.exports = __webpack_public_path__ + "static/img/basic01.c36ffff5.jpg";